<template>
    <div class="bank-details">
        <div class="card-table rounded-bottom">
            <b-form role="form" class="mt-4" @submit.prevent="updateOtherLoan">
                <b-row>                
                    <b-col md="8" cols="12">
                        <b-form-group label="Product">
                            <el-select v-model="form.prod_oth_type" placeholder="Select" allow-create filterable>
                                <el-option
                                    v-for="(item, index) in PRODUCT_TYPES"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Product Details">
                            <b-form-input
                                v-model="form.prod_oth_detail"
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Product Value (RM)">
                            <CurrencyInput
                                v-model="form.prod_oth_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Additional Cost">
                            <b-form-input
                            v-model="form.prod_oth_add_cost"
                            type="number"
                            step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col  md="8" cols="12">
                        <b-form-group label="Loan Officer">
                            <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" @change="loanOfficerDetails">
                                <el-option
                                v-for="loan_officer in userLoanOfficerList"
                                :key="loan_officer.id"
                                :label="loan_officer.name"
                                :value="loan_officer.id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>
        
                    <b-col md="8" cols="10">
                        <b-form-group label="Arrangement Fee Amount">
                            <b-form-input
                            v-model="form.prod_oth_agreement_rate"
                            type="number"
                            step="0.01"
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Arrangement Fee SST">
                            <b-form-radio-group
                                v-model="form.prod_oth_agreement_rate_sst"
                                :options="SST_OPTIONS"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                            <b-form-group label="Total Arrangement Fee (RM)">
                            <b-form-input
                            v-model="form.prod_oth_agreement_fees"
                            type="text"
                            required
                            disabled
                            placeholder="0.00"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Payment Mode">
                            <el-select v-model="form.prod_oth_pay_mode" placeholder="Select" filterable>
                                <el-option
                                    v-for="(item, index) in PAYMENT_MODES"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Submission Date">
                            <b-form-input
                            v-model="form.prod_submitted_date"
                            type="date"
                            @change="onSubmissionDateChange"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Status">
                            <el-select v-model="form.status" placeholder="Select" @change="handleStatusChange(form.status)">
                                <el-option
                                    v-for="(item, index) in list_sub_other_loan_status"
                                    :key="index"
                                    :label="item.status"
                                    :value="item.status"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Approved Date">
                                <b-form-input
                                v-model="form.prod_acceptance_date"
                                type="date"
                                :disabled="!checkAccess(['p_product__manage'])"
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="8" v-if="auth_user.account_info.role_type === 'admin'">
                      <b-form-group label="Invoice Date">
                        <el-date-picker
                          v-model="form.prod_invoice_date"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="Select invoice time and date"
                          :disabled="form.prod_invoice_date_disabled"
                          @input="onInvoiceDateInput"
                        ></el-date-picker>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col cols="4" class="mx-auto text-center mt-3 pt-2" v-if="auth_user.account_info.role_type === 'admin'"> 
                    <b-form-group>
                        <b-button block variant="outline-primary"
                                    @click="exportToGoogleCalendar(form.prod_invoice_date)" 
                                    class="el-icon-date"
                                    style="cursor: pointer;">
                            Export to Calendar
                        </b-button>
                    </b-form-group>
                </b-col> -->
                    <b-col md="8" cols="12">
                        <b-button block variant="primary" class="mb-5" type="submit" :disabled="is_loading_update">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Button, DatePicker } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader,
        debounce
    } from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import {PRODUCT_OTHER_LOAN} from '@/assets/js/options.js'
import {SST_OPTIONS} from '@/assets/js/options.js'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useProductStore } from '@/stores/productStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { useNotificationStore } from '@/stores/notificationStore'

export default {
    props: ['product'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        CurrencyInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Button.name]: Button,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            prodSSADetails: null, 
            status:[],
            PRODUCT_TYPES: PRODUCT_OTHER_LOAN.PRODUCT_TYPES,
            PAYMENT_MODES: PRODUCT_OTHER_LOAN.PAYMENT_MODES,
            is_loading_update: false,
            prod_invoice_date_disabled: false,
            form: {
                prod_oth_type: '',
                prod_oth_detail: '',
                prod_oth_value: 0,
                prod_oth_pay_mode: '',
                prod_oth_agreement_rate: 0,
                prod_oth_agreement_rate_sst: 0,
                prod_oth_agreement_fees: 0,
                status: '',
                prod_loan_officer_id:'',
                prod_acceptance_date: null,
                prod_invoice_date:'',
                prod_submitted_date: null,
                prod_oth_add_cost: '',
            },
            SST_OPTIONS: SST_OPTIONS,
        }
    },
    watch:{
        product: {
            handler(newVal){
                this.form.prod_oth_type = newVal.product_detail.prod_oth_type,
                this.form.prod_oth_detail = newVal.product_detail.prod_oth_detail,
                this.form.prod_oth_value = parseFloat(newVal.product_detail.prod_oth_value)
                this.form.prod_oth_pay_mode = newVal.product_detail.prod_oth_pay_mode
                this.form.prod_oth_agreement_rate = parseFloat(newVal.product_detail.prod_oth_agreement_rate),
                this.form.prod_oth_agreement_rate_sst = parseFloat(newVal.product_detail.prod_oth_agreement_rate_sst),
                this.form.prod_oth_agreement_fees = parseFloat(newVal.product_detail.prod_oth_agreement_fees)
                this.form.prod_loan_officer_id = newVal.prod_loan_officer_id,
                this.form.prod_acceptance_date = ((newVal.prod_acceptance_date) ? this.formatDate(newVal.prod_acceptance_date,'Y-m-d') : null)
                this.form.prod_invoice_date = newVal.prod_invoice_date,
                this.form.prod_submitted_date = ((newVal.prod_submitted_date) ? this.formatDate(newVal.prod_submitted_date,'Y-m-d') : null)
                this.form.status = newVal.prod_status
                this.form.prod_oth_add_cost = newVal.product_detail.prod_oth_add_cost
                this.prodSSADetails = newVal.prod_ssa_detail;
            },
            immediate: true
        },
        'form.status': {
            // handler(newStatus, oldStatus) {
            //     if (newStatus === 'Approved' && newStatus !== oldStatus) {
            //         const selectedSSA = this.prodSSADetails;
            //         if (selectedSSA) {
            //             this.sendApprovalEmailToSSA(selectedSSA.name, selectedSSA.email);
            //         }
            //     }
            // },
            // immediate: false 
            handler(newStatus, oldStatus) {
                if (newStatus === 'Approved' && newStatus !== oldStatus) {
                    this.sendApprovalEmail();
                } 
                else if (newStatus === 'Declined by Client' && newStatus !== oldStatus) {
                    this.sendRejectionEmail();
                } 
                else if (newStatus === 'Pending Approval' && newStatus !== oldStatus) {
                    this.sendPendingApprovalEmail();
                }
            },
            immediate: false,
        },
        'form':{
            handler(newVal){
                if(newVal){ 
                    let sst_fee = parseFloat(this.form.prod_oth_agreement_rate) * parseFloat(this.form.prod_oth_agreement_rate_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.prod_oth_agreement_rate) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.prod_oth_agreement_fees = 0
                    }else{
                        this.form.prod_oth_agreement_fees = arrangement_fee_amount
                    }
                }
            },
            deep: true
        }
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useAccessControlStore, ['userLoanOfficerList']),
				...mapState(useProductStore, ['list_sub_other_loan_status']),
    },
    created() {
    // Call the checkInvoiceDateDisabled method when the modal is opened to initialize prod_invoice_date_disabled
    this.$watch("show_edit_bank", (newVal) => {
      if (newVal) {
        this.checkInvoiceDateDisabled();
      }
    });
  },
    methods: {
        ...mapActions(useProductStore, ['checkGenerateCommission']),
        ...mapActions(useMessagingStore, ['sendEmail']),
        ...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate', 'fetchNotificationTemplate']),
        async handleStatusChange(newStatus) {
            try {
                // Fetch the notification template using the trigger point 'LEAD_STATUS_CHANGE'
                const notificationTemplate = await this.fetchNotificationTemplate('CASE_STATUS_CHANGE');
                if (notificationTemplate && notificationTemplate.is_active) { 
                let message = notificationTemplate.notif_temp_message

                // Construct the notification content
                let contentNotification = {
                  noti_message: "Case #"+ this.product.prod_id +" : "+message+" "+newStatus,
                  noti_url: window.location.origin + '/casesListings',
                    microservice_code: 'product',
                    noti_related_type: 'product',
                    noti_related_id: this.product.prod_id,
                };

                // Get recipients from the template
                const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));

                for (const recipient of recipients) {
                          if (!isNaN(recipient)) { // Check if recipient is a valid integer
                            let notification = { ...contentNotification, noti_user_id: recipient };
                            
                            // let notification = { ...contentNotification, noti_user_id: recipients }

                            this.createNotification(notification)
                        }
                }   
              }
                this.notifySuccess('Notification sent successfully.');

            } catch (error) {
                console.error('Failed to send notification:', error);
                this.notifyError('Failed to send notification.');
            }
        },
        async sendEmailToLoanOfficer(loanOfficerName, loanOfficerEmail) {
            const emailData = {
                to: loanOfficerEmail, 
                subject: `New Case Assigned: [ Other Loan Case - ${this.product.prod_id} ]`,
                body: `Dear ${loanOfficerName},\n\nA new case has been assigned to you. Please review the details at your earliest convenience.\n\nThank you,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post( services.product + 'send-email', emailData , {headers: getHeader()}); // Adjust the API endpoint as per your backend route
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        loanOfficerDetails() {
            const selectedLoanOfficer = this.userLoanOfficerList.find(officer => officer.id === this.form.prod_loan_officer_id);
            if (selectedLoanOfficer) {
                this.sendEmailToLoanOfficer(selectedLoanOfficer.name ,  selectedLoanOfficer.email);
            }
        },
        async sendPendingApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_PENDING_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {

              const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

              // Prepare the email data
              const emailData = {
                to: recipients, // Array of email addresses
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
              };
              
              await this.sendEmail(emailData);
              this.notifySuccess('Pending Approval email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        async sendApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_APPROVE');
            if (emailTemplate && emailTemplate.is_active == 1) {

                const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                // Prepare the email data
                const emailData = {
                  to: recipients, // Array of email addresses
                  subject: emailTemplate.notif_temp_title,
                  body: emailTemplate.notif_temp_message
                  .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                  .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                };

                await this.sendEmail(emailData);
                this.notifySuccess('Approval email sent successfully.');
              }
            } 
            catch (error) {
                console.error('Failed to send email:', error);
                this.errorFunction(error);
            }
          },
        async sendRejectionEmail() {
          try {
          const emailTemplate = await this.fetchEmailTemplate('CASE_REJECT');
          if (emailTemplate && emailTemplate.is_active == 1) {

          const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

          // Prepare the email data
          const emailData = {
            to: recipients, // Array of email addresses
            subject: emailTemplate.notif_temp_title,
            body: emailTemplate.notif_temp_message
            .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
            .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
          };

              await this.sendEmail(emailData);
              this.notifySuccess('Rejection email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        //     const emailData = {
        //         to: ssaEmail,
        //         subject: `Loan Approval Notification: [ Other Loan Case - ${otherLoanId} ]`,
        //         body: `Dear ${ssaName},\n\nWe are pleased to inform you that the application for other loan case ${otherLoanId} has been approved. Final approval details can be referred to in the system's last update.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
        //     };
        //     try {
        //         const response = await axios.post(services.product + 'send-email', emailData, { headers: getHeader() });
        //         console.log('Email sent successfully:', response);
        //     } catch (error) {
        //         console.error('Error sending email:', error);
        //     }
        // },
        async sendEmailToSSA(ssaName, ssaEmail) {
            const emailData = {
                to: ssaEmail, 
                subject: `Application Update Processing with [ Other Loan Case - ${this.product.prod_id} ]`,
                body: `Dear ${ssaName},\n\nWe are pleased to inform that your client - ${this.product.prod_customer_name} application is currently being processed by ${this.form.bank_name} at ${this.form.prod_bnk_submission_date}.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post(services.product + 'send-email', emailData , {headers: getHeader()});
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        async onSubmissionDateChange() {
            const selectedSSA = this.prodSSADetails;
            // console.log(selectedSSA.name, selectedSSA.email);
            if (selectedSSA) {
                this.sendEmailToSSA(selectedSSA.name, selectedSSA.email);
            }
        },
        onInvoiceDateInput(newValue, oldValue) {
            // Only proceed if the new value is different from the old value
            if (newValue !== oldValue) {
                // Display confirmation dialog
                const confirmed = confirm("Please confirm your decision: Once the invoice date is set, it cannot be changed. Proceed with Yes or cancel to quit and set later.");

                if (!confirmed) {
                    // User canceled the confirmation, revert to the old value
                    this.form.prod_invoice_date = oldValue;
                } else {
                    // User confirmed, disable the input
                    this.$set(this.form, 'prod_invoice_date_disabled', true);
                }
            }
        },    
        checkInvoiceDateDisabled() {
          this.form.prod_invoice_date_disabled = !!this.form.prod_invoice_date;
        },
        getOtherLoanStatus(){
            axios.get(services.lookup + 'other_loan_status', {headers: getHeader()})
            .then(res => {
                this.status = res.data.data.filter((item) => item.group === 'sub')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        updateOtherLoan(){
            const status = this.list_sub_other_loan_status.find((item) => item.status === this.form.status)

            if(!status || !status.parent){
                this.errorFunction(null, 'Status could not be found.')
                return
            }

            const other_loan = {
                prod_customer_id: this.product.prod_customer_id,
                prod_customer_name: this.product.prod_customer_name,
                prod_type: this.product.prod_type,
                prod_customer_basket: this.product.prod_customer_basket,
                prod_status: this.product.prod_status,
                prod_agent_id: this.product.prod_agent_id,
                prod_agent_username: this.product.prod_agent_username,
                prod_main_status: status.parent.status,
                prod_status: status.status,
                prod_submitted_date: this.form.prod_submitted_date ? this.form.prod_submitted_date+" 00:00:00" : null,
                prod_acceptance_date: this.form.prod_acceptance_date ? this.form.prod_acceptance_date+" 00:00:00" : null,
                prod_loan_officer_id: this.form.prod_loan_officer_id,
                prod_invoice_date: this.form.prod_invoice_date,
                product_detail: {                    
                    prod_oth_type: this.form.prod_oth_type,
                    prod_oth_detail: this.form.prod_oth_detail,
                    prod_oth_value: this.form.prod_oth_value,
                    prod_oth_pay_mode: this.form.prod_oth_pay_mode,
                    prod_oth_agreement_rate: this.form.prod_oth_agreement_rate,
                    prod_oth_agreement_rate_sst: this.form.prod_oth_agreement_rate_sst,
                    prod_oth_agreement_fees: this.form.prod_oth_agreement_fees,
                    prod_oth_add_cost: this.form.prod_oth_add_cost
                }
            }

            this.is_loading_update = true
            axios.post(services.product + 'product/'+this.product.prod_id, other_loan, {headers: getHeader()})
                .then(res => {
                    this.is_loading_update = false
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Other Cases</b> - Successfully Updated.')
										this.checkGenerateCommission(this.product,'other_loan_status',this.form.status)
                })
                .catch(e => {
                    this.is_loading_update = false
                    this.errorFunction(e)
                })
        },
        exportToGoogleCalendar(appointmentAt) {
            const caseName = this.product.prod_customer_name

            // Check if appointmentAt is not empty
            if (!this.isEmpty(appointmentAt)) {
                // Format the appointment date for the Google Calendar link
                const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
                // Create the Google Calendar link
                const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, caseName);
                // Open the link in a new tab
                window.open(googleCalendarLink, '_blank');
            }
        },

        formatGoogleCalendarDate(appointmentAt) {
            const date = new Date(appointmentAt);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}`;
        },

        generateGoogleCalendarLink(formattedDate, caseName) {
            // Generate Google Calendar link with necessary details
            const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${caseName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

            return googleCalendarLink;
        },
    }
}
</script>